import { CommonModule } from '@angular/common'
import {
  ChangeDetectionStrategy,
  Component,
  TemplateRef,
  ViewEncapsulation,
  contentChild,
  input,
  output,
} from '@angular/core'
import { FormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'

import { MenuItem } from 'primeng/api'
import { SelectModule } from 'primeng/select'

export type SelectItemConfig = {
  options: any[]
  selectedOption: any
  onSelect: (option: any) => void
  optionLabel?: string
  filterBy?: string
}

export type FlxBreadcrumbItem = MenuItem & {
  type?: string
  relativeTo?: any
  selectConfig?: SelectItemConfig
}

export interface BreadcrumbItemClickEvent {
  /**
   * Browser event.
   */
  originalEvent: Event
  /**
   * Selected menu item .
   */
  item: MenuItem
}

@Component({
  selector: 'flx-breadcrumbs',
  imports: [RouterModule, CommonModule, SelectModule, FormsModule],
  templateUrl: './breadcrumbs.component.html',
  styleUrl: './breadcrumbs.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
})
export class BreadcrumbsComponent {
  model = input.required<FlxBreadcrumbItem[]>()

  selectTemplate = contentChild<TemplateRef<any> | undefined>('selectTemplate')
  itemClick = output<BreadcrumbItemClickEvent>()

  onClick(event: Event, item: MenuItem): void {
    if (item.disabled) {
      event.preventDefault()
      return
    }

    if (!item.url && !item.routerLink) {
      event.preventDefault()
    }

    if (item.command) {
      item.command({
        originalEvent: event,
        item,
      })
    }

    this.itemClick.emit({
      originalEvent: event,
      item,
    })
  }

  /** A link navigates by itself; listeners are only told it was clicked. */
  onLinkClick(event: Event, item: MenuItem): void {
    this.itemClick.emit({ originalEvent: event, item })
  }
}
